import React from "react";

import MarkdownHelper from '../../utils/MarkdownHelper';
import ReactMarkdown from "react-markdown"

import { ProcessSteps, transformProcessSteps } from "../mam3/ProcessStep";
import TermsAndConditions from '../../subcomponents/TermsAndConditions';
import Logo from '../../subcomponents/Logo';

import Flag from '../../subcomponents/Flag'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const DetailViewApp = props => {
    const processSteps = transformProcessSteps(props.campaign)

    const hasFlag = ['Alle', 'App Detail'].some(val => props.flagFilter.includes(val))

    const renderDetailViewApp = (
        <div className="ad-cp-detail-view-app border">

            <div className="bg-white">
                <div className="ad-cp-detail-view-app__image-wrapper">
                    <img className="img-fluid"
                        src={props.campaign.image_3_2}
                        alt="detail view app" />

                    {hasFlag && <Flag text={props.campaign.flagstoerer} appearance={props.campaign.flageye_catcher} />}
                </div>

                <div className="ad-cp-detail-view-app__content">
                    {props.logoFilter.includes('App Logo verbergen') ? '' : (<Logo logo={props.partnerLogo} format="narrow" teaserClass="teaser-logo detail-view-logo"/>)}

                    {props.campaign.title_3_long ? 
                        (<h2 className={`ad-cp-detail-view-app__content__heading ${props.logoFilter.includes('App Logo verbergen') ? 'ad-cp-detail-view-app__content__heading-margin' : ''}`}>
                            <ReactMarkdown {...MarkdownHelper.basicTypes()}
                                        source={props.campaign.title_3_long}
                                        renderers={{ root: React.Fragment }}
                                        escapeHtml={false} />
                        </h2>) : null
                    }
                    <p className="ad-cp-detail-view-app__content__data">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                                    source={props.campaign.copy_long}
                                    escapeHtml={false}  />
                    </p>
                    {props.campaign.main_benefit_offerpage ? 
                        (<p className="ad-cp-detail-view-app__content__period-of-validity js-mam-symbol-content">
                            <ReactMarkdown {...MarkdownHelper.allTypes()}
                                        source={props.campaign.main_benefit_offerpage}
                                        escapeHtml={false}  />
                        </p>) : null
                    }

                    <div className="key-facts">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                                    source={MarkdownHelper.parse(props.campaign.key_facts_web)}
                                    escapeHtml={false} />
                    </div>

                    <div className="process-container-title">
                        <ReactMarkdown {...MarkdownHelper.basicTypes()}
                                    source={MarkdownHelper.parse(props.campaign.process_container_headline)}
                                    escapeHtml={false} />
                    </div>
                    <ProcessSteps
                        steps={processSteps}
                        isMobile behavior="stack"
                    />
                    <TermsAndConditions
                        isApp={true}
                        content={props.campaign.terms_and_conditions}
                        title={props.campaign.terms_and_conditions_title}
                    />
                    <FootnotesFromContext
                        showWarningText={props.footnotesWarningText}
                    />

                    <button className="btn btn--mobile">
                        {props.campaign.button_cta_external}
                    </button>
                </div>
            </div>
        </div>
    )

    return (
        <div className="app-type app-spacers">

            <div className="app-view mb-md">
                {renderDetailViewApp}
            </div>
        </div>
    )

};

export default DetailViewApp;


// WEBPACK FOOTER //
// ./src/components/ads/app/DetailViewApp.js